<template>
  <b-button
    :style="buttonStyle"
    :variant="variant"
    :size="size"
    :type="type"
    :disabled="loading || disabled"
    @click="$emit('click')"
  >
    <span
      v-if="loading"
      class="spinner-border spinner-border-sm mr-2"
    ></span>
    {{ text }}
  </b-button>
</template>

<script>
export default {
  name: 'LoadingButton',
  props: {
    text: {
      type: String,
      default: 'Lưu',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
      default: 'sm',
    },
    type: {
      type: String,
      default: 'submit',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonStyle: {
      type: Object,
      default: () => ({ fontWeight: '600', width: '70px' }),
    },
  },
};
</script>
